import { Absense } from './Absense';
import { BidAward } from './BidAward';
import { StateList } from './StateList';
import { Vacation } from './Vacation';

export class WBidStateCollection {
  CompanyVA?: string;
  DataSource?: string;
  DefaultName?: string;
  IsModified: boolean;
  SeniorityListItem: SeniorityListItem;
  StateList: StateList[] = [];
  StateUpdatedTime: string;
  SyncVersion: string;
  FVVacation: Absense[] = [];
  Vacation?: Vacation[] = [];
  Version?: string;
  FileName?: string;
  BidAwards: BidAward[] = [];
  SubmittedResult?: string;
  Bidchoices?:string;
}
export class StateFiles extends WBidStateCollection {
  employeeId: string;
  bidId: string;
  stateKey: string;
}

export class SeniorityListItem {
  public SeniorityNumber: number;
  public TotalCount: number;
}
